import {UserBillingAddress} from "./userBillingAddress";

export class User {
  id: string;
  company: string;
  title: string;
  firstname: string;
  lastname: string;
  zip: string;
  businessAccount: boolean;
  town: string;
  street: string;
  houseNumber: string;
  mail: string;
  billingAddress: UserBillingAddress

  constructor() {}

}
